export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите отделения ', trigger: 'blur' },
    ],
};
